'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

var _magnificPopup = require('magnific-popup');

var _magnificPopup2 = _interopRequireDefault(_magnificPopup);

var _customFrameSize = require('./customFrameSize');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  bindUIActions();
};

//Update page
var update = function update() {
  cart.getState().then(function (cart) {
    var $cartTotal = (0, _jquery2.default)(_dom2.default.cartTotal);
    var itemCount = cart.item_count;

    if (itemCount == 0) {
      $cartTotal.removeClass('has-items');
    }

    $cartTotal.text(itemCount);
  });

  _jquery2.default.get('/cart?view=contents').then(function (response) {
    var $cartContainer = (0, _jquery2.default)(_dom2.default.cartContainer);
    $cartContainer.html(response);
  }).done(function () {
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  });
};

//Call the quickview product
var quickviewInit = function quickviewInit(current, edit) {
  var $current = (0, _jquery2.default)(current);
  var handle = $current.attr('data-product-handle');
  var $quickviewContainer = (0, _jquery2.default)(_dom2.default.quickviewContainer);

  //Tie poster and addon together
  var $lineItem = $current.closest(_dom2.default.lineItem);
  var posterKey = $lineItem.attr('data-key');
  var posterHandle = $lineItem.attr('data-product-handle');
  var posterVariantId = $lineItem.attr('data-variant-id');
  var posterWidth = parseFloat($lineItem.attr('data-product-width'));
  var posterHeight = parseFloat($lineItem.attr('data-product-height'));
  var addonKey = (0, _jquery2.default)(current).closest(_dom2.default.addonLineItem).attr('data-key');

  _jquery2.default.get('/products/' + handle + '?view=quickview').then(function (response) {
    $quickviewContainer.html(response);

    //Set attributes to tie poster and addon together
    var $quickview = $quickviewContainer.find(_dom2.default.quickview);
    $quickview.attr('data-poster-key', posterKey);
    $quickview.attr('data-poster-product-handle', posterHandle);
    $quickview.attr('data-poster-variant-id', posterVariantId);

    if (edit) {
      $quickview.attr('data-edit-key', addonKey);
    }

    //Preselect frame size
    if (posterWidth != undefined && posterHeight != undefined && (0, _jquery2.default)(_dom2.default.frameSizeTrigger).length > 0) {
      var matchingPreset = false;

      (0, _jquery2.default)(_dom2.default.frameSizeTrigger).each(function () {
        var $current = (0, _jquery2.default)(this);
        var frameWidth = parseFloat($current.attr('data-frame-width'));
        var frameHeight = parseFloat($current.attr('data-frame-height'));

        if (frameWidth == posterWidth && frameHeight == posterHeight) {
          matchingPreset = true;
          $current.trigger('click');
        }
      });

      if (!matchingPreset) {
        (0, _jquery2.default)(_dom2.default.customFrameSizeTrigger).trigger('click');
        (0, _jquery2.default)(_dom2.default.customFrameWidth).val(posterWidth);
        (0, _jquery2.default)(_dom2.default.customFrameHeight).val(posterHeight);
        (0, _customFrameSize.findRange)(posterWidth, posterHeight);
      }
    }
  }).done(function () {
    _jquery2.default.magnificPopup.open({
      type: 'inline',
      preloader: false,
      items: {
        src: '#quickview'
      },
      closeMarkup: '<span class="mfp-close icon icon-close-24"></span>'
    });
  });
};

//Update QTY
var quantityAdjust = function quantityAdjust(current) {
  var qtyInput = (0, _jquery2.default)(current).closest(_dom2.default.addonQty).find(_dom2.default.addonQtyInput);
  var qty = parseInt(qtyInput.val());

  if ((0, _jquery2.default)(current).attr('data-quantity-minus') != undefined) {
    qty = qty - 1;
    if (qty <= 0) {
      qty = 0;
    }
  } else {
    qty = qty + 1;
  }

  qtyInput.val(qty).trigger('change');
};

var quantityUpdate = function quantityUpdate(current) {
  var quantity = parseInt((0, _jquery2.default)(current).val());

  if (quantity > 0) {
    var key = (0, _jquery2.default)(current).closest(_dom2.default.addonLineItem).attr('data-key');

    cart.updateItem(key, { quantity: quantity }).then(function (cart) {
      update();
    });
  } else {
    removeAddon();
  }
};

//Add to cart
var addToCart = function addToCart(newPosterKey, quantity) {
  var $quickview = (0, _jquery2.default)(_dom2.default.quickview);

  //Prep all needed data
  var variantId = parseInt($quickview.find(_dom2.default.productVariant).val());

  var properties = {
    "_addon_product": "true",
    "_addon_poster_key": newPosterKey
  };

  $quickview.find(_dom2.default.property).each(function (index) {
    var $current = (0, _jquery2.default)(this);

    if ($current.val() != "") {
      var propertyName = $current.attr('name').replace('properties[', '').replace(']', '');
      properties[propertyName] = $current.val();
    }
  });

  if (!quantity) {
    quantity = 1;
  }

  cart.addItem(variantId, { quantity: quantity, properties: properties }).then(function (item) {
    update();
    _jquery2.default.magnificPopup.close();
  });
};

//Remove Addon
var removeAddon = function removeAddon(key, posterKey) {
  var quantity = parseInt((0, _jquery2.default)(_dom2.default.addonLineItem + '[data-key="' + key + '"]').find(_dom2.default.addonQtyInput).val());
  cart.removeItem(key).then(function (cart) {
    if ((0, _jquery2.default)(_dom2.default.quickview).attr('data-edit-key') != undefined) {
      addToCart(posterKey, quantity);
    } else {
      updatePoster(false, posterKey);
    }
  });
};

//Update Addon Line Item
var updateAddon = function updateAddon() {
  var $quickview = (0, _jquery2.default)(_dom2.default.quickview);

  //Prep all needed data
  var editKey = $quickview.attr('data-edit-key');
  var posterKey = $quickview.attr('data-poster-key');

  removeAddon(editKey, posterKey);
};

// Update Poster
var updatePoster = function updatePoster(state, posterKey, index) {
  //Prep all needed data
  var $posterLineItem = (0, _jquery2.default)(_dom2.default.lineItem + '[data-key="' + posterKey + '"]');
  var quantity = parseInt($posterLineItem.find(_dom2.default.qtyInput).val());

  var properties = {
    '_addon_selected': state
  };

  //Catch any existing line item properties
  $posterLineItem.find(_dom2.default.lineItemProperty).each(function () {
    var $current = (0, _jquery2.default)(this);
    var propertyKey = $current.attr('data-property-key');
    var propertyValue = $current.attr('data-property-value');

    if (propertyKey != '_addon_selected') {
      properties[propertyKey] = propertyValue;
    }
  });

  //Update Item
  cart.updateItem(posterKey, { quantity: quantity, properties: properties }).then(function (cart) {
    if (state) {
      //Pass updated poster key so the addon can tie into the poster
      var item = cart.items[index];
      var newPosterKey = item.key;
      addToCart(newPosterKey);
    } else {
      update();
    }
  });
};

//Get index to be able to find right line item to match addon with
var posterIndex = function posterIndex(posterKey) {
  cart.getItemIndex(posterKey).then(function (index) {
    //adjust to base 0
    var itemIndex = index - 1;
    //Update poster
    updatePoster(true, posterKey, itemIndex);
  });
};

var bindUIActions = function bindUIActions() {
  //Show or hide addon items
  (0, _jquery2.default)(document).on('click', _dom2.default.addonTrigger, function () {
    var $current = (0, _jquery2.default)(this);
    var $addon = $current.closest(_dom2.default.addon);

    if (!$addon.hasClass('is-active')) {
      $current.find('.icon').removeClass('icon-add-16').addClass('icon-close-16');
      $addon.addClass('is-active');
    } else {
      $current.find('.icon').removeClass('icon-close-16').addClass('icon-add-16');
      $addon.removeClass('is-active');
    }
  });

  //Trigger addon item quickview
  (0, _jquery2.default)(document).on('click', _dom2.default.addonItemTrigger, function () {
    quickviewInit(this);
  });

  //Add addon item to cart
  (0, _jquery2.default)(document).on('submit', _dom2.default.quickviewForm, function (e) {
    e.preventDefault();
    //Must update poster before adding item so we can create a relationship between the two line items
    if ((0, _jquery2.default)(_dom2.default.quickview).attr('data-edit-key') != undefined) {
      updateAddon();
    } else {
      var posterKey = (0, _jquery2.default)(_dom2.default.quickview).attr('data-poster-key');
      posterIndex(posterKey);
    }
  });

  //Edit Addon Item
  (0, _jquery2.default)(document).on('click', _dom2.default.addonEditTrigger, function () {
    quickviewInit(this, 'edit');
  });

  //Remove Addon Item
  (0, _jquery2.default)(document).on('click', _dom2.default.addonRemoveTrigger, function () {
    var $current = (0, _jquery2.default)(this);
    var key = $current.closest(_dom2.default.addonLineItem).attr('data-key');
    var posterKey = $current.closest(_dom2.default.lineItem).attr('data-key');

    //Visually remove to provide immediate feedback to customer
    $current.closest(_dom2.default.addonLineItem).remove();

    //Remove Item
    removeAddon(key, posterKey);
  });

  //Update QTY
  (0, _jquery2.default)(document).on('click', _dom2.default.addonQtyAdjust, function () {
    quantityAdjust(this);
  });

  (0, _jquery2.default)(document).on('blur, change', _dom2.default.addonQtyInput, function () {
    quantityUpdate(this);
  });
};